import changeCase from "change-case";

/**
 * @param {string} text
 * @param {string} caseType
 * camel - test string -> testString
 * constant - test string -> TEST_STRING
 * dot - test string -> test.string
 * header - test string -> Test-String
 * isLower - test string -> true
 * isUpper - test string -> false
 * lower - TEST STRING -> test string
 * lcFirst - TEST -> tEST
 * no - test string -> test string
 * param - test string -> test-string
 * pascal - test string -> TestString
 * path - test string -> test/string
 * sentence - testString -> Test string
 * snake - test string -> test_string
 * swap - Test String -> tEST sTRING
 * title - a simple test -> A Simple Test
 * upper - test string -> TEST STRING
 * ucFirst - test -> Test
 * @returns {string}
 */
export default (text, caseType) => {
  const availableTypes = [
    "camel",
    "constant",
    "dot",
    "header",
    "isLower",
    "isUpper",
    "lower",
    "lcFirst",
    "no",
    "param",
    "pascal",
    "path",
    "sentence",
    "snake",
    "swap",
    "title",
    "upper",
    "ucFirst"
  ];
  if (availableTypes.indexOf(caseType) === -1) return text;

  switch (caseType) {
    case "lcFirst":
      caseType = "lowerCaseFirst";
      break;
    case "ucFirst":
      caseType = "upperCaseFirst";
      break;
    default:
      caseType += "Case";
  }

  return changeCase[caseType](text);
};
